import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { CloneProjectTaskArgs, CloneProjectTaskResult } from '@ztechapps/common.contract'
import { projectDocumentFragment } from './graphql'

export const cloneProjectTaskQuery = gql`
  mutation cloneProjectTask($input: CloneProjectTaskArgs!) {
    cloneProjectTask(input: $input) {
      project {
        ...projectDocumentFragment
      }
      task {
        _id
      }
    }
  }
  ${projectDocumentFragment}
`

export const useCloneProjectTask = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<CloneProjectTaskResult, CloneProjectTaskArgs> => {
  query = query ?? cloneProjectTaskQuery

  return useActionMutation({
    query,
    ...props,
  })
}
